import { StateEnum } from "../../../Models/Bases/StateEnum";
import { BaseService } from "../../Bases/BaseService";
import { ValidationResponse } from "../../Bases/ValidationResponse";

export class UsuarioOperacaoService extends BaseService {
    public selecionarValidos(usuarioOperacoes: any) {
        return usuarioOperacoes?.filter((e: any) => e.state != StateEnum.Deleted) ?? [];
    }

    public salvar(usuarioOperacao: any, usuarioOperacoes: any) {
        if (!this.numberIsFilled(usuarioOperacao.operacao_id) &&
            !this.numberIsFilled(usuarioOperacao.operacao_permissao_grupo_id)) {
            return new ValidationResponse(null, 'Preencha ao menos um dos campos solicitados!');
        }

        let validation = usuarioOperacoes?.filter(
            (e: any) =>
                usuarioOperacao.id != e.id &&
                usuarioOperacao.operacao_id == e.operacao_id &&
                usuarioOperacao.operacao_permissao_grupo_id == e.operacao_permissao_grupo_id &&
                e.state != StateEnum.Deleted);

        if (validation.length > 0) {
            return new ValidationResponse(null, 'Operação já inserida!');
        }

        let ids = usuarioOperacoes?.map((x: any) => x.id) ?? [];
        let min = Math.min.apply(null, ids);
        usuarioOperacao.id = min > 0 ? -1 : min - 1;
        usuarioOperacao.state = StateEnum.Inserted;
        usuarioOperacoes = usuarioOperacoes.concat(usuarioOperacao);

        return new ValidationResponse(usuarioOperacoes);
    }

    public apagar(id: number, usuarioOperacoes: any) {
        if (id > 0) {
            usuarioOperacoes.forEach((e: any) => e.state = (e.id == id ? StateEnum.Deleted : e.state));
        }
        else {
            usuarioOperacoes = usuarioOperacoes?.filter((e: any) => e.id != id);
        }

        return new ValidationResponse(usuarioOperacoes);
    }
}